import { useCallback } from 'react';
import { streamMetricSlug } from '../../Graphs/sensor-utils';
import type { DriveUnitPortOccupancy } from '../../../redux/ApplicationSlice';
import { motorStreamKeysForPorts, motorStreamKeysForSelectedPorts } from '../../../utils/electronicsDashboardUtils';
import type { PersistDashboardWidgetContentPatch } from './usePersistDashboardWidgetContent';

type MotorStreamPortsPatch = Pick<PersistDashboardWidgetContentPatch, 'sensorKeys' | 'selectedMotorPorts'>;

/** Persists motor/mechanism stream keys and selected ports when the user changes motors in a toolbar. */
export function useMotorStreamPortsChange({
  dataKey,
  driveUnitPorts,
  projectCode,
  streamKind,
  persistWidgetContent,
}: {
  dataKey: string;
  driveUnitPorts: DriveUnitPortOccupancy[];
  projectCode: string;
  streamKind: 'motor' | 'mechanism';
  persistWidgetContent: (patch: MotorStreamPortsPatch) => void;
}) {
  return useCallback(
    (ports: number[]) => {
      const metric = streamMetricSlug(dataKey);
      const sensorKeys = motorStreamKeysForSelectedPorts(driveUnitPorts, projectCode, metric, ports, streamKind);
      persistWidgetContent({
        sensorKeys: sensorKeys.length ? sensorKeys : motorStreamKeysForPorts(dataKey, ports),
        selectedMotorPorts: ports,
      });
    },
    [dataKey, driveUnitPorts, persistWidgetContent, projectCode, streamKind]
  );
}
